// mainMenu.js
import { Tooltip } from "@mui/material";
import React from "react";
import { PAGES_LIST } from "../../Helpers/constants";
import { Page } from "../../Helpers/interfaces";
import { useNavigate } from "react-router-dom";

interface MainMenuProps {
  selectedPage: number | string; // Adjust based on your application's logic
  setSelectedPage: React.Dispatch<React.SetStateAction<number>>; // Adjust based on your application's logic
}

const MainMenu: React.FC<MainMenuProps> = ({
  selectedPage,
  setSelectedPage,
}) => {
  const navigate = useNavigate();
  return (
    <div className="md:flex flex-row gap-12 items-center justify-start tracking-tighter sticky w-10/12 ml-12 hidden">
      {PAGES_LIST.map((page: Page) => (
        <Tooltip
          key={page.id}
          title={page.disabled ? "This page is not available" : ""}
          placement="top"
          arrow
          disableHoverListener={!page.disabled}
          disableFocusListener={!page.disabled}
          disableTouchListener={!page.disabled}
        >
          <div
            key={page.id}
            onClick={() => {
              if (!page.disabled) {
                navigate(page.toURL);
              }
            }}
            className={`cursor-pointer text-2xl font-inter p-2 hover:bg-gray-200 hover:font-semibold transition-all duration-300 ${[
              page.id === selectedPage && "text-gray-800",
              page.id !== selectedPage && "text-gray-500",
              page.disabled && "font-thin",
              page.disabled && "font-base",
            ]
              .filter(Boolean)
              .join(" ")}`}
          >
            {page.name}
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default MainMenu;
